import React, { Component } from "react";
import { Table, Button } from "antd";
import moment from "moment";

import { emitter } from "../../../../common/utils/emitter";
import { alert } from "../../../../common/utils/alert";
import { apiCustomerPR } from "../../../../api/api-customer-payment-request";
import { columns, handleMoneyValue, columnsDriverless } from "./data-table";
import { TotalRow } from "../../journey-diary/journey-detail/total-row";
import { dateFormatVi } from "../../../../common/utils/static-data";

const paymentRequestColumns = [
  {
    title: "",
    dataIndex: "name",
    key: "name",
    className: "column-200 td-left",
  },
  {
    title: "Đơn giá",
    dataIndex: "price",
    key: "price",
    className: "column-80",
    render: (price) => (
      <span>{price === 0 ? "-" : handleMoneyValue(price)}</span>
    ),
  },
  {
    title: "Số lượng",
    dataIndex: "count",
    key: "count",
    className: "column-80",
    render: (count) => <span>{count === 0 ? "-" : count}</span>,
  },
  {
    title: "Đơn vị",
    dataIndex: "unit",
    key: "unit",
    className: "column-80",
  },
  {
    title: "Thành tiền",
    dataIndex: "total_price",
    key: "total_price",
    className: "column-80",
    render: (price, record) => (
      <span>
        {record.count !== null
          ? price === 0
            ? "-"
            : handleMoneyValue(price)
          : price === 0
          ? "0"
          : handleMoneyValue(price)}
      </span>
    ),
  },
];

export class PaymentRequestDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      payment_data: [],
      total: {},
      xScroll: window.innerHeight <= 800 ? 400 : window.innerHeight - 450,
      contract_type: 1,
    };
  }

  async componentDidMount() {
    window.addEventListener("resize", () => {
      if (window.innerHeight <= 800) {
        this.setState({ xScroll: 400 });
      } else {
        this.setState({ xScroll: window.innerHeight - 500 });
      }
    });
  }

  showDetailPR = (data) => {
    this.getData(data);
    this.setState({
      contract_type: data.contract_type_id,
    });
  };

  getData = async (data) => {
    try {
      emitter.emit("FETCH_LOADING", true);
      if (data.contract_type_id === 1) {
        const result = await apiCustomerPR.getPaymentRequestDetail(data.id);
        emitter.emit("FETCH_LOADING", false);
        if (result.status === "success") {
          const dataConvert = result.data.customer_journey_diaries.map(
            (value, index) => {
              return {
                index: index + 1,
                ...value,
                data: value,
                gps_work_time: [
                  value.working_time_gps_from,
                  value.working_time_gps_to,
                ],
                week_day: dateFormatVi[moment(value.date).format("dddd")],
              };
            }
          );
          const paymentData = result.data.customer_payment_request_items;
          this.setState(
            {
              payment_data: paymentData,
              dataTable: dataConvert.slice(0, dataConvert.length - 1),
              total: dataConvert[dataConvert.length - 1],
              pr_info: result.data,
            },
            () => {}
          );
        }
      } else {
        const result = await apiCustomerPR.getPaymentRequestDetailDriverless(
          data.id
        );
        emitter.emit("FETCH_LOADING", false);
        if (result.status === "success") {
          const dataConvert = result.data.customer_journey_diaries.map(
            (value, index) => {
              return {
                index: index + 1,
                ...value,
                data: value,
              };
            }
          );
          const paymentData = result.data.customer_payment_request_items;
          this.setState(
            {
              payment_data: paymentData,
              dataTable: dataConvert.slice(0, dataConvert.length - 1),
              total: dataConvert[dataConvert.length - 1],
              pr_info: result.data,
            },
            () => {}
          );
        }
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  handleExportJourneyDiary = async () => {
    try {
      emitter.emit("FETCH_LOADING", true);
      const res = await apiCustomerPR.exportPaymentRequestCustomer(
        this.state.pr_info.id
      );
      if (res === "success") {
        alert("success", "Export thành công");
      } else {
        alert("error", "Không export thành công");
      }
    } catch (error) {
    } finally {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  columnsPayment = () => {
    const { contract_type } = this.state;

    return contract_type === 1
      ? columns(this, true).filter(
          (i) =>
            i.key !== "signature_comment" &&
            i.key !== "signature_image_url" &&
            i.key !== "signature_status" &&
            i.key !== "note" &&
            i.key !== "CT011"
        )
      : columnsDriverless(this);
  };

  render() {
    const { dataTable, pr_info, xScroll, total, payment_data, contract_type } =
      this.state;

    return (
      <div className="payment-request-detail">
        <div className="title-container">
          <div className="title-payment">AVIS CAR LICENSE</div>
          <div className="title-payment">
            AN HOA PHAT RENT A CAR COMPANY LIMITED
          </div>
          <div className="title-payment">
            5th Floor - 11 Pham Hung Street - My Dinh 2 Ward- Nam Tu Liem Dist -
            Ha Noi - Viet Nam
          </div>
          <div className="title-payment">
            Brand Ho Chi Minh, No. 27, 06 Street, Quarter 5, Hiep Binh Chanh
            Ward, Thu Duc City, Ho Chi Minh City, Vietnam.
          </div>
          <img
            className="payment-request-logo"
            src={require("../../../../assets/images/payment-request-logo.png")}
          />
        </div>
        <div className="info-container">
          <div className="text">
            Tên khách hàng: {pr_info ? pr_info.customer_name : ""}
          </div>
          <div className="text">Admin: {pr_info ? pr_info.admin_name : ""}</div>
          <div className="text">User: {pr_info?.name_finds?.join(", ")}</div>
          <div className="text">
            Địa chỉ: {pr_info ? pr_info.customer_address : ""}
          </div>
          <div className="text">
            Từ ngày:{" "}
            {pr_info ? moment(pr_info.from_date).format("DD/MM/YYYY") : ""} đến
            ngày {pr_info ? moment(pr_info.to_date).format("DD/MM/YYYY") : ""}
          </div>
          <div className="text">
            Tài xế: {pr_info ? pr_info.driver_name : ""}
          </div>
          <div className="text">
            Biển KS: {pr_info ? pr_info.vehicle_number_plate : ""}
          </div>
        </div>
        <Table
          className="customer-pr-detail-table"
          rowKey={(record) => record.id}
          style={{ width: "100%" }}
          dataSource={dataTable}
          pagination={false}
          scroll={{ x: true, y: xScroll, scrollToFirstRowOnChange: true }}
          columns={this.columnsPayment()}
          summary={(pageData) => {
            return (
              <TotalRow
                columns={this.columnsPayment()}
                total={total}
                pageData={pageData}
                isCustomer
                isDriverLess={contract_type === 1 ? false : true}
              />
            );
          }}
        />
        <div className="payment-request-fee">
          <Table
            className="payment-request-table"
            style={{ width: "100%" }}
            //scroll={{ x: true, scrollToFirstRowOnChange: true }}
            columns={paymentRequestColumns}
            bordered
            pagination={false}
            dataSource={payment_data}
          />

          <div
            style={{
              marginTop: 10,
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <Button type="primary" onClick={this.handleExportJourneyDiary}>
              Export
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
